import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "../context/LanguageContext";
import { useSeoProfiles } from "../context/SeoContext";

export const SEO = ({ pageKey, title, description, image, type = "website", schema }) => {
  const { lang, dir, t } = useLang();
  const { profiles } = useSeoProfiles();
  const profile = pageKey ? profiles[pageKey] : null;
  const profileTitle = profile?.meta_title?.[lang];
  const resolvedTitle = profileTitle || title;
  const fullTitle = resolvedTitle
    ? (resolvedTitle.includes("Smart Farmland") ? resolvedTitle : `${resolvedTitle} — Smart Farmland`)
    : `${t.seo.home.title} — Smart Farmland`;
  const desc = profile?.meta_description?.[lang] || description || t.seo.home.description;
  const img = profile?.og_image || image || "https://images.unsplash.com/photo-1545292470-391a7b77b8a2?w=1200&q=80";
  const path = profile?.canonical_path || (typeof window !== "undefined" ? window.location.pathname : "");
  const canonical = typeof window !== "undefined" ? `${window.location.origin}${path}` : undefined;
  const robots = `${profile?.index === false ? "noindex" : "index"}, ${profile?.follow === false ? "nofollow" : "follow"}`;
  const keywords = profile?.keywords?.[lang]?.join(", ");
  const generatedSchema = profile ? {
    "@context": "https://schema.org",
    "@type": profile.schema_type || "WebPage",
    name: resolvedTitle,
    description: desc,
    url: canonical,
    image: img,
  } : null;
  return (
    <Helmet>
      <html lang={lang} dir={dir} />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={robots} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content={type} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:locale" content={lang === "tr" ? "tr_TR" : lang === "ar" ? "ar_SA" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {canonical && <link rel="canonical" href={canonical} />}
      {(schema || generatedSchema) && <script type="application/ld+json">{JSON.stringify(schema || generatedSchema)}</script>}
    </Helmet>
  );
};
